// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 930) return "static/chunks/930-e00edf7fb6b781d3.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"258":"17c22e805f2083cb","633":"74d43ce123cdd9fe"}[chunkId] + ".js";
};